import { Alert, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import { KnowledgeManage } from '../components/KnowledgeManage'
import { PageHeader, PageLoading } from '../components/ui'
import { useAdminAuth } from '../lib/useAdminAuth'

export default function KnowledgeLibrary() {
  const navigate = useNavigate()
  const { ready, loggedIn } = useAdminAuth()

  if (!ready) return <PageLoading />

  if (!loggedIn) {
    return (
      <div className="public-page-panel">
        <PageHeader
          title="个人知识库"
          description="录入、上传文档并自动切片向量化，供对话与检索使用。"
        />
        <Alert
          type="info"
          showIcon
          message="请先登录"
          description="知识维护需使用管理账号登录（默认 admin / admin123）。登录后将返回本页。"
          action={
            <Button
              type="primary"
              onClick={() => void navigate('/manage/login?redirect=/knowledge')}
            >
              去登录
            </Button>
          }
        />
      </div>
    )
  }

  return (
    <div className="public-page-panel">
      <KnowledgeManage
        knowledgeScope="personal"
        title="个人知识库"
        description="上传文档后自动切片并向量化，供对话与检索使用。"
      />
    </div>
  )
}
